import axios from "@/axios";

export default {
    all(payload) {
        return axios.get('cities', payload);
    },
}
